import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import API_PATH from "../../../../constants/config.json";
import ReactEcharts from 'echarts-for-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cookies from 'js-cookie';
import '../../../../css/trafficCountAmTab.css';
import {getPeakColor} from "../../../../utils/UtilsFunctions";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '165px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      fontSize: '16pt',
      margin: '0px',
    },
    '& MuiGrid-item': {
      textAlign: "center",
    }
  },
  rootBox: {
    flexGrow: 1,
  },
  Intersection: {
    padding: '5px',
    height: '100%',
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .trafficCountsSelect': {
      padding: '5px',
      color: '#333',
      paddingRight: '50px',
      fontSize: '14pt',
    }
  }, tabblock: {
    border: '1px solid #24618E',
    paddingTop: '0px',
    marginBottom: '10px',
    borderRadius: '5px 5px 5px 5px',
    width: '100%',
    float: 'left',
    height: '600px',
    overflowY: 'scroll',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  appBarMain: {
    paddingLeft: '28%',
    marginTop: '-25px',
  },
  tableHead: {
    fontWeight: 'normal',
    textAlign: 'center',
    color: '#333',
    padding: 0,
    background: '#fff',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '12pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '25pt',
      lineHeight: '25pt',
    },
  },
  titleTD: {
    textAlign: 'left',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '12pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  dataTD: {
    textAlign: 'center',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '12pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  tableContent: {
    width: '60%',
  },
  tableMidBlock: {
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        padding: '15px 5px',
      },
    },
    '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
      backgroundColor: ' #f2f2f2 !important',
    },
  },
  headingP1: {
    fontWeight: "bolder",
    float: "left",
    margin: "0px",
    marginTop: "5px",
    fontFamily: "Avenir_Black !important",
    width: '35%',
    marginRight: '125px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '16pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '26pt',
    },
  },
  headingP2: {
    fontWeight: "bolder",
    margin: "0px",
    marginTop: "5px",
    fontFamily: "Avenir_Black !important",
    width: '35%',
    float: 'left',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '16pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '26pt',
    },
  },
  itemPara: {
    margin: '0 0 10px',
    fontFamily: "Avenir_Black !important",
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
    },
  },
  tempGrapImage: {
    float: 'left',
    '@media only screen and (max-width: 1279px)': {
      width: '100%',
      height: '620px',
      '& .echarts-for-react': {
        height: '600px !important',
      }
    },
    '@media only screen and (min-width: 1280px) and (max-width: 1439px)': {
      width: '90%',
      height: '620px',
      '& .echarts-for-react': {
        height: '600px !important',
      }
    },    
    '@media only screen and (min-width: 1440px) and (max-width: 2400px)': {
      width: '90%',
      height: '620px',
      '& .echarts-for-react': {
        height: '600px !important',
      }
    },
    '@media only screen and (min-width: 2401px) and (max-width: 3500px)': {
      width: '90%',
      height: '900px',
      '& .echarts-for-react': {
        height: '875px !important',
      }
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '25px',
      width: '90%',
      height: '1220px',
      '& .echarts-for-react': {
        height: '1200px !important',
      }
    }
  },
  TableBlock: {
    width: '100%',
    float: 'left',
    marginBottom: '10px',
    '& .mainDivBlock': {
      width: '100%',
      float: 'left',
      '& .MuiTableContainer-root': {
        overflowX: 'unset',
      }
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  textHiglight: {
    fontWeight: 'bolder',
    textAlign: 'center',
    color: '#333',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '12pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  dataAll: {
    margin: '10px 0',
    fontFamily: 'Avenir_Black !important',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '15pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '25pt',
    },
  },
  spanAign: {
    fontFamily: "Avenir_Black !important",
    '@media only screen and (max-width: 3500px)': {
      fontSize: '16pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '26pt',
    },
  },
  turningCountData: {
    '& span': {
      fontSize: '12pt',
    },
    '& span.amnbIn': {
      top: '137px',
      left: '157px',
      position: 'absolute',
    },
    '& span.amNbLeft': {
      top: '195px',
      left: '245px',
      position: 'absolute',
    },
    '& span.amnbEx': {
      top: '137px',
      left: '240px',
      position: 'absolute',
    },
    '& span.amNbMiddle': {
      top: '195px',
      left: '200px',
      position: 'absolute',
    },
    '& span.amNbRight': {
      top: '195px',
      left: '163px',
      position: 'absolute',
    },
    '& span.amsbIn': {
      top: '467px',
      left: '240px',
      position: 'absolute',
    },
    '& span.amsbEx': {
      top: '467px',
      left: '150px',
      position: 'absolute',
    },
    '& span.amebIn': {
      top: '258px',
      left: '390px',
      position: 'absolute',
    },
    '& span.amebEx': {
      top: '342px',
      left: '390px',
      position: 'absolute',
    },
    '& span.amwbIn': {
      top: '344px',
      left: '25px',
      position: 'absolute',
    },
    '& span.amwbIn': {
      top: '344px',
      left: '20px',
      position: 'absolute',
    },
    '& span.amwbEx': {
      top: '259px',
      left: '20px',
      position: 'absolute',
    },
    '& span.amSbLeft': {
      top: '408px',
      left: '159px',
      position: 'absolute',
    },
    '& span.amEbLeft': {
      top: '337px',
      left: '312px',
      position: 'absolute',
    },
    '& span.amWbLeft': {
      top: '259px',
      left: '85px',
      position: 'absolute',
    },
    '& span.amSbRight': {
      top: '407px',
      left: '240px',
      position: 'absolute',
    },
    '& span.amEbRight': {
      top: '260px',
      left: '312px',
      position: 'absolute',
    },
    '& span.amWbRight': {
      top: '342px',
      left: '85px',
      position: 'absolute',
    },
    '& span.amCenterData': {
      top: '300px',
      left: '196px',
      position: 'absolute',

    },
    '& span.amSbMiddle': {
      top: '408px',
      left: '198px',
      position: 'absolute',
    },
    '& span.amEbMiddle': {
      top: '300px',
      left: '313px',
      position: 'absolute',
    },
    '& span.amWbMiddle': {
      top: '302px',
      left: '85px',
      position: 'absolute',
    },
  },
  truckMovData: {
    '& span': {
      fontSize: '12pt',
    },
    '& span.amnbIn': {
      top: '137px',
      left: '157px',
      position: 'absolute',
    },
    '& span.amNbLeft': {
      top: '195px',
      left: '245px',
      position: 'absolute',
    },
    '& span.amnbEx': {
      top: '137px',
      left: '250px',
      position: 'absolute',
    },
    '& span.amNbMiddle': {
      top: '195px',
      left: '200px',
      position: 'absolute',
    },
    '& span.amNbRight': {
      top: '195px',
      left: '163px',
      position: 'absolute',
    },
    '& span.amsbIn': {
      top: '485px',
      left: '240px',
      position: 'absolute',
    },
    '& span.amsbEx': {
      top: '485px',
      left: '153px',
      position: 'absolute',
    },
    '& span.amebIn': {
      top: '258px',
      left: '390px',
      position: 'absolute',
    },
    '& span.amebEx': {
      top: '350px',
      left: '390px',
      position: 'absolute',
    },
    '& span.amwbIn': {
      top: '344px',
      left: '25px',
      position: 'absolute',
    },
    '& span.amwbIn': {
      top: '350px',
      left: '20px',
      position: 'absolute',
    },
    '& span.amwbEx': {
      top: '262px',
      left: '20px',
      position: 'absolute',
    },
    '& span.amSbLeft': {
      top: '420px',
      left: '159px',
      position: 'absolute',
    },
    '& span.amEbLeft': {
      top: '346px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbLeft': {
      top: '259px',
      left: '85px',
      position: 'absolute',
    },
    '& span.amSbRight': {
      top: '420px',
      left: '240px',
      position: 'absolute',
    },
    '& span.amEbRight': {
      top: '260px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbRight': {
      top: '350px',
      left: '85px',
      position: 'absolute',
    },
    '& span.amCenterData': {
      top: '300px',
      left: '196px',
      position: 'absolute',
    },
    '& span.amSbMiddle': {
      top: '420px',
      left: '198px',
      position: 'absolute',
    },
    '& span.amEbMiddle': {
      top: '300px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbMiddle': {
      top: '302px',
      left: '85px',
      position: 'absolute',
    },
  },
  bicycleMovlData: {
    '& span': {
      fontSize: '12pt',
    },
    '& span.amNbLeft': {
      top: '195px',
      left: '245px',
      position: 'absolute',
    },
    '& span.amNbMiddle': {
      top: '195px',
      left: '200px',
      position: 'absolute',
    },
    '& span.amNbRight': {
      top: '195px',
      left: '163px',
      position: 'absolute',
    },
    '& span.amSbLeft': {
      top: '420px',
      left: '159px',
      position: 'absolute',
    },
    '& span.amEbLeft': {
      top: '337px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbLeft': {
      top: '259px',
      left: '80px',
      position: 'absolute',
    },
    '& span.amSbRight': {
      top: '420px',
      left: '245px',
      position: 'absolute',
    },
    '& span.amEbRight': {
      top: '260px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbRight': {
      top: '337px',
      left: '80px',
      position: 'absolute',
    },
    '& span.amCenterData': {
      top: '300px',
      left: '196px',
      position: 'absolute',
    },
    '& span.amSbMiddle': {
      top: '420px',
      left: '198px',
      position: 'absolute',
    },
    '& span.amEbMiddle': {
      top: '300px',
      left: '323px',
      position: 'absolute',
    },
    '& span.amWbMiddle': {
      top: '302px',
      left: '80px',
      position: 'absolute',
    },
  },
  pedVolData: {
    '& span.amNbWalk': {
      position: 'absolute',
      left: '207px',
      top: '175px',
    },
    '& span.amSbWalk': {
      position: 'absolute',
      left: '207px',
      top: '420px',
    },
    '& span.amEbWalk': {
      top: '295px',
      left: '336px',
      position: 'absolute',
    },
    '& span.amWbWalk': {
      position: 'absolute',
      left: '60px',
      top: '295px',
    }
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

let turingImgSrc = require("./../../../../assets/images/turning.svg");
let trackImage = require("./../../../../assets/images/truck.svg");
let bicycleImage = require("./../../../../assets/images/cycle.svg");
let pedestrianImage = require("./../../../../assets/images/Walk.svg");

//Start AM component code...
const AM = props => {
  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [myOptions, setmyOptions] = React.useState({})
  const [getResponseData, setResponseData] = React.useState({})
  const [defaultTimeArray, setDefaultTimeArray] = React.useState([
    '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'])

  const [intersectionImagesTurnig, setIntersectionImagesTurnig] = React.useState(turingImgSrc);
  const [intersectionImagesTrackImage, setIntersectionImagesTrackImage] = React.useState(trackImage);
  const [intersectionImagesBicycle, setIntersectionImagesBicycle] = React.useState(bicycleImage);
  const [intersectionImagesPedestrain, setIntersectionImagesPedestrain] = React.useState(pedestrianImage);
  const [turningCountData, setTurningCountData] = React.useState(
    {
      nbIn: 0,
      nbEx: 0,
      sbIn: 0,
      sbEx: 0,
      ebIn: 0,
      ebEx: 0,
      wbIn: 0,
      wbEx: 0,
      nbLeft: 0,
      sbLeft: 0,
      ebLeft: 0,
      wbLeft: 0,
      nbRight: 0,
      sbRight: 0,
      ebRight: 0,
      wbRight: 0,
      nbMiddle: 0,
      sbMiddle: 0,
      ebMiddle: 0,
      wbMiddle: 0,
      centerData: 0,
      nuturn:0,
      suturn:0,
      euturn:0,
      wsuturn:0
    });
  const [truckCountData, setTruckCountData] = React.useState({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
  const [pedestrianData, setPedestrianData] = React.useState({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });

  const [bicycleCountData, setBicycleCountData] = React.useState({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
  const [peakData, setPeakData] = React.useState();
  const [peakDate, setPeakDate] = React.useState();
  const [selectedDate, setSelectedDate] = React.useState([]);
  const [dateVal, setDateVal] = React.useState([]);
  const [AMdata, setAMdata] = React.useState(null);
  const [MIDdata, setMIDdata] = React.useState(null);
  const [PMdata, setPMdata] = React.useState(null);

  const [startPeakHour, setStartPeakHour] = React.useState(null);
  const [endPeakHour, setEndPeakHour] = React.useState(null);
  const [startPeakMin, setStartPeakMin] = React.useState(null);
  const [endPeakMin, setEndPeakMin] = React.useState(null);
  const [getResponseApproches, setResponseApproches] = React.useState([]);
  const [getDashedArray, setDashedArray] = React.useState([]);
  const [getLoader,setLoaderDisable] = React.useState(false);
  let flagPeakH=true;
  let flagPeakM=true;

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  React.useEffect(() => {
    if (props.stationId) {
      getIntersectionTrafficData();
      if (props.AMdata && props.AMdata.hour && props.AMdata.hour.startdate && props.AMdata.hour.enddate) {
        let startValtime = props.AMdata.hour.startdate;
        let endValtime = props.AMdata.hour.enddate;
        setStartPeakHour(startValtime);
        setEndPeakHour(endValtime);
      } else {
        setStartPeakHour(null);
        setEndPeakHour(null);
      }

      if (props.AMdata && props.AMdata.minute && props.AMdata.minute.startdate && props.AMdata.minute.enddate) {
        let startValtime = props.AMdata.minute.startdate;
        let endValtime = props.AMdata.minute.enddate;        
        setStartPeakMin(startValtime);
        setEndPeakMin(endValtime);
      } else {
        setStartPeakMin(null);
        setEndPeakMin(null);
      }

      if (props.AMdata && props.AMdata.startdate && props.AMdata.enddate) {
        getTurningMovement();
        getTruckPercentage();
        getPedestrianMovement();
        getBicycleMovement();
      }
    }
    
  }, [props.AMdata, props.stationId])

  function myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray) {
    setmyOptions({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'none'
        },
        textStyle: {
          fontSize: sessionStorage.getItem('intTabWidth') >= 3501 ? 30 : 14,
        }
      },
      title: {
        text: 'Entering Volumes:',
        bottom: '6%',
        left: '45%',
        textStyle: {
          fontSize: sessionStorage.getItem('intTabWidth') >= 3501 ? 30 : 15,
        }
      },
      legend: {
        orient: 'horizontal',
        data: ['NB', 'SB', 'EB', 'WB'],
        bottom: '1%',
        textStyle: {
          fontSize: sessionStorage.getItem('intTabWidth') >= 1200 && sessionStorage.getItem('intTabWidth') <= 3500 ? 15 : sessionStorage.getItem('intTabWidth') >= 3501 ? 30 : 14,
        }
      },
      grid: {
        bottom: sessionStorage.getItem('intTabWidth') >= 1800 && sessionStorage.getItem('intTabWidth') <= 3500 ? '25%' : sessionStorage.getItem('intTabWidth') >= 3501 ? '20%' : sessionStorage.getItem('intTabWidth') >= 1550 ? '30%' : '35%',
        height: 'auto',
        top: '20px',
        left: sessionStorage.getItem('intTabWidth') >= 1200 && sessionStorage.getItem('intTabWidth') <= 3500 ? '40px' : sessionStorage.getItem('intTabWidth') >= 3501 ? '100px' : '40px',
        right: '15px',
      },
      xAxis: {
        axisLabel: {
          rotate: 55,
          fontSize: 15,
          interval: 0,
          fontSize: sessionStorage.getItem('intTabWidth') >= 1200 && sessionStorage.getItem('intTabWidth') <= 3500 ? 13 : sessionStorage.getItem('intTabWidth') >= 3501 ? 24 : 12,
        },
        type: 'category',
        data: dateTimeArray,
        splitLine: {
          show: true
        },
      },
      yAxis: {
        type: 'value',      
        splitLine: {
          show: true
        },
        axisLabel: {
          fontSize: sessionStorage.getItem('intTabWidth') >= 1200 && sessionStorage.getItem('intTabWidth') <= 3500 ? 13 : sessionStorage.getItem('intTabWidth') >= 3501 ? 24 : 12,
        },
      },
      series: [
        {
          name: 'NB',
          type: 'bar',
          itemStyle: {
            color: "#4EC1E8",
          },         
          stack: 'five',
          label: {
            show: false,
            position: 'insideRight'
          },
          data: northGraph,
        },
        {
          name: 'SB',
          type: 'bar',
          itemStyle: {
            color: "#297DA0",
          },         
          stack: 'five',
          label: {
            show: false,
            position: 'insideRight'
          },
          data: southGraph,
        },
        {
          name: 'EB',
          type: 'bar',
          itemStyle: {
            color: "#5C9CEC",
          },         
          stack: 'five',
          label: {
            show: false,
            position: 'insideRight'
          },
          data: eastGraph,
        },
        {
          name: 'WB',
          type: 'bar',
          itemStyle: {
            color: "#3361A1",
          },         
          stack: 'five',
          label: {
            show: false,
            position: 'insideRight'
          },
          data: westGraph,
        },
      ]
    })
  }
  //End Css Code ....

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const checkCondition = (north, east, west, south) => {
    let checkArray = [];
    Object.values(north).map((obj, index) => {
      checkArray.push(obj);
    })
    Object.values(east).map((obj, index) => {
      checkArray.push(obj);
    })
    Object.values(west).map((obj, index) => {
      checkArray.push(obj);
    })
    Object.values(south).map((obj, index) => {
      checkArray.push(obj);
    })
    return checkArray.includes("--");
  }


  //This Method is use for get intersection traffic data .... Start
  const getIntersectionTrafficData = async() => {
    try {
     await axios({
        method: 'post',
        url: API_URL + API_PATH.getIntersectionTrafficData,
        data: {
          stationId: props.stationId,
          startdate: props.AMdata.startdate,
          enddate: props.AMdata.enddate
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
      }).then(function (response) {
        if (response && (response.data.data && response.data.approaches)) {
          setResponseData(response.data.data);
          setResponseApproches(response.data.approaches);
          let northGraph = [];
          let southGraph = [];
          let eastGraph = [];
          let westGraph = [];
          let dateTimeArray = [];
          let dashedArray = [];

          response.data.data.map((ele, index) => {
            dateTimeArray.push(ele.starttime)
            northGraph.push(ele.north.sum);
            southGraph.push(ele.south.sum);
            eastGraph.push(ele.east.sum);
            westGraph.push(ele.west.sum);
            dashedArray.push(checkCondition(ele.north, ele.east, ele.west, ele.south))
          })


          setDashedArray(dashedArray);
          myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray);

        } else {
          setResponseData({});          
        }
      }).catch((err) => {       
        setResponseData({});
      })

    }
    catch (error) {
      setResponseData({});      
    }
  }
  //This Method is use for get intersection traffic data .... End

  

  //This Method is use for get TurningMovement data .... start
  const getTurningMovement = async() => {
    try {
     await axios({
        method: 'post',
        url: API_URL + API_PATH.getTurningMovement,
        data: {
          "stationId": props.stationId,
          "start": props.AMdata.hour.peakstartdate,
          "end": props.AMdata.hour.peakenddate,
          "hour_volume": props.AMdata.hour.volume,
          "minute_volume": props.AMdata.minute.volume
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setTurningCountData({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            centerData: data.phf ? data.phf : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0
          })
        } else {
          setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        }
      })
        .catch(function (error) {
          setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        })
    }
    catch (error) {
      setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
    }
  }
  //This Method is use for get TurningMovement data .... end


  //This Method is use for get TruckPercentage data .... start
  const getTruckPercentage = async() => {
    setLoaderDisable(true);
    try {
     await axios({
        method: 'post',
        url: API_URL + API_PATH.getTruckPercentage,
        data: {
          "stationId": props.stationId,
          "start": props.AMdata.hour.peakstartdate,
          "end": props.AMdata.hour.peakenddate,
        }
      }).then(function (response) {
        if (response && response.data.data) {
         setLoaderDisable(false);
          let data = response.data.data;
          setTruckCountData({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0
          });
        } else {
         setLoaderDisable(false);
          setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        }
      })
        .catch(function (error) {
         setLoaderDisable(false);
          setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        })
    }
    catch (error) {
      setLoaderDisable(false);
      setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
    }
  }
  //This Method is use for get TruckPercentage data .... end

  
  //This Method is use for get PedestrianMovement data .... start
  const getPedestrianMovement = async() => {
    setLoaderDisable(true);
    try {
      await axios({
        method: 'post',
        url: API_URL + API_PATH.getPedestrianMovement,
        data: {
          "stationId": props.stationId,
          "start": props.AMdata.hour.peakstartdate,
          "end": props.AMdata.hour.peakenddate,
        }
      }).then(function (response) {
        if (response && response.data.data) {
         setLoaderDisable(false);
          let data = response.data.data;
          setPedestrianData({
            pedNb: data.north.middle ? data.north.middle : 0, pedSb: data.south.middle ? data.south.middle : 0, pedEb: data.east.middle ? data.east.middle : 0, pedWb: data.west.middle ? data.west.middle : 0
          });
        } else {
          setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        }
      })
        .catch(function (error) {
         setLoaderDisable(false);
          setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        })
    }
    catch (error) {
      setLoaderDisable(false);
      setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
    }
  }
  //This Method is use for get PedestrianMovement data .... end

  
  //This Method is use for get BicycleMovement data .... start
  const getBicycleMovement = async() => {
    setLoaderDisable(true);
    try {
     await axios({
        method: 'post',
        url: API_URL + API_PATH.getBicycleMovement,
        data: {
          "stationId": props.stationId,
          "start": props.AMdata.hour.peakstartdate,
          "end": props.AMdata.hour.peakenddate,
        }
      }).then(function (response) {
        if (response && response.data.data) {
         setLoaderDisable(false);
          let data = response.data.data;
          setBicycleCountData({
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
          });
        } else {
         setLoaderDisable(false);
          setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        }
      })
        .catch(function (error) {
         setLoaderDisable(false);
          setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        })
    }
    catch (error) {
      setLoaderDisable(false);
      setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
    }
  }
  //This Method is use for get BicycleMovement data .... end
  

  return (
    <React.Fragment>
      <CssBaseline />
      {getLoader == false ? <div className={classes.Intersection}>       
        <p className={classes.headingP1}>AM Peak Hour:&nbsp;
        {startPeakHour && endPeakHour ? <span className={classes.spanAign}>{startPeakHour} - {endPeakHour}</span> : <span className={classes.spanAign}>NA </span>}
        </p>
        <p className={classes.headingP2}> AM Peak 15-Min:&nbsp;        
          {startPeakMin && endPeakMin ? <span className={classes.spanAign}>{startPeakMin} - {endPeakMin}</span> : <span className={classes.spanAign}>NA </span>}
        </p>
        <Grid container className={classes.rootBox} spacing={spacing}>
          <Grid item xs={12}>
            <div className='amBoxes'>
              <Grid container justify="center" spacing={spacing}>
                <Grid xs={12} md={3} item>
                  <Paper className={classes.paper} style={{ textAlign: "center" }}>
                    <div className='fourBox fourBox-first'>
                      <p className={classes.itemPara}>Turning Movement Volume</p>                      
                      <div>
                        <img src={intersectionImagesTurnig} style={{ width: "95%", padding:'25px' }} />
                        {/*<div className='arrowImg'><img src={require("./../../../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
                        <span className='amnbIn'>{turningCountData.sbIn}</span>
                        <span className='amnbEx'>{turningCountData.sbEx}</span>
                        <span className='amsbIn'>{turningCountData.nbIn}</span>
                        <span className='amsbEx'>{turningCountData.nbEx}</span>
                        <span className='amebIn'>{turningCountData.wbIn}</span>
                        <span className='amebEx'>{turningCountData.wbEx}</span>
                        <span className='amwbIn'>{turningCountData.ebIn}</span>
                        <span className='amwbEx'>{turningCountData.ebEx}</span>
                        <span className='amNbLeft'>{turningCountData.sbLeft}</span>
                        <span className='amSbLeft'>{turningCountData.nbLeft}</span>
                        <span className='amEbLeft'>{turningCountData.wbLeft}</span>
                        <span className='amWbLeft'>{turningCountData.ebLeft}</span>
                        <span className='amNbRight'>{turningCountData.sbRight}</span>
                        <span className='amSbRight'>{turningCountData.nbRight}</span>
                        <span className='amEbRight'>{turningCountData.wbRight}</span>
                        <span className='amWbRight'>{turningCountData.ebRight}</span>
                        <span className='amCenterData' title='Peak Hour Factor'>{turningCountData.centerData}</span>
                        <span className='amNbMiddle'>{turningCountData.sbMiddle}</span>
                        <span className='amSbMiddle'>{turningCountData.nbMiddle}</span>
                        <span className='amEbMiddle'>{turningCountData.wbMiddle}</span>
                        <span className='amWbMiddle'>{turningCountData.ebMiddle}</span>

                        <span className='nUturn'>{turningCountData.suturn}</span>
                        <span className='sUturn'>{turningCountData.nuturn}</span>
                        <span className='eUturn'>{turningCountData.wsuturn}</span>
                        <span className='wUturn'>{turningCountData.euturn}</span>
                      </div>                      
                    </div>
                  </Paper>
                </Grid>
                <Grid xs={12} md={3} item>
                  <Paper className={classes.paper} style={{ textAlign: "center" }}>
                    <div className='fourBox fourBox-second'>
                      <p className={classes.itemPara}>Truck Percentage</p>                     
                      <div>
                        <img src={intersectionImagesTrackImage} style={{ width: "95%", padding:'25px' }} />
                        {/*<div className='arrowImg'><img src={require("./../../../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
                        <span className='amnbIn'>{truckCountData.sbIn}</span>
                        <span className='amnbEx'>{truckCountData.sbEx}</span>
                        <span className='amsbIn'>{truckCountData.nbIn}</span>
                        <span className='amsbEx'>{truckCountData.nbEx}</span>
                        <span className='amebIn'>{truckCountData.wbIn}</span>
                        <span className='amebEx'>{truckCountData.wbEx}</span>
                        <span className='amwbIn'>{truckCountData.ebIn}</span>
                        <span className='amwbEx'>{truckCountData.ebEx}</span>
                        <span className='amNbLeft'>{truckCountData.sbLeft}</span>
                        <span className='amSbLeft'>{truckCountData.nbLeft}</span>
                        <span className='amEbLeft'>{truckCountData.wbLeft}</span>
                        <span className='amWbLeft'>{truckCountData.ebLeft}</span>
                        <span className='amNbRight'>{truckCountData.sbRight}</span>
                        <span className='amSbRight'>{truckCountData.nbRight}</span>
                        <span className='amEbRight'>{truckCountData.wbRight}</span>
                        <span className='amWbRight'>{truckCountData.ebRight}</span>
                        <span className='amCenterData'>&nbsp;</span>
                        <span className='amNbMiddle'>{truckCountData.sbMiddle}</span>
                        <span className='amSbMiddle'>{truckCountData.nbMiddle}</span>
                        <span className='amEbMiddle'>{truckCountData.wbMiddle}</span>
                        <span className='amWbMiddle'>{truckCountData.ebMiddle}</span>

                        <span className='nUturn'>{truckCountData.suturn}</span>
                        <span className='sUturn'>{truckCountData.nuturn}</span>
                        <span className='eUturn'>{truckCountData.wsuturn}</span>
                        <span className='wUturn'>{truckCountData.euturn}</span>
                      </div>                     
                    </div>
                  </Paper>
                </Grid>
                <Grid xs={12} md={3} item>
                  <Paper className={classes.paper} style={{ textAlign: "center" }}>
                    <div className='fourBox fourBox-third'>
                      <p className={classes.itemPara}>Pedestrian Count</p>                      
                      <div>
                        <img src={intersectionImagesPedestrain} style={{ width: "95%", padding:'25px' }} />
                        {/*<div className='arrowImg'><img src={require("./../../../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
                        <span className='amNbWalk'>{pedestrianData.pedSb}</span>
                        <span className='amSbWalk'>{pedestrianData.pedNb}</span>
                        <span className='amEbWalk'>{pedestrianData.pedWb}</span>
                        <span className='amWbWalk'>{pedestrianData.pedEb}</span>
                      </div>                      
                    </div>
                  </Paper>
                </Grid>
                <Grid xs={12} md={3} item>
                  <Paper className={classes.paper} style={{ textAlign: "center" }}>
                    <div className='fourBox fourBox-fourth'>
                      <p className={classes.itemPara}>Bicycle Count</p>                      
                      <div>
                        <img src={intersectionImagesBicycle} style={{ width: "95%", padding:'25px' }} />                        
                        {/*<div className='arrowImg'><img src={require("./../../../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
                        <span className='amNbLeft'>{bicycleCountData.sbLeft}</span>                        
                        <span className='amSbLeft'>{bicycleCountData.nbLeft}</span>{/*nbRight*/}
                        <span className='amEbLeft'>{bicycleCountData.wbLeft}</span>
                        <span className='amWbLeft'>{bicycleCountData.ebLeft}</span>{/*ebRight*/}                        
                        <span className='amNbRight'>{bicycleCountData.sbRight}</span>
                        <span className='amSbRight'>{bicycleCountData.nbRight}</span>{/*nbLeft*/}                        
                        <span className='amEbRight'>{bicycleCountData.wbRight}</span>
                        <span className='amWbRight'>{bicycleCountData.ebRight}</span>{/*ebLeft*/}                        
                        <span className='amNbMiddle'>{bicycleCountData.sbMiddle}</span>
                        <span className='amSbMiddle'>{bicycleCountData.nbMiddle}</span>
                        <span className='amEbMiddle'>{bicycleCountData.wbMiddle}</span>
                        <span className='amWbMiddle'>{bicycleCountData.ebMiddle}</span>
                      </div>                      
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <div className={classes.tempGrapImage}>          
          {myOptions && JSON.stringify(getResponseData) != "{}" ? <ReactEcharts option={myOptions} style={{ marginLeft: '5px' }} /> :
            <span style={{
              position: 'relative',
              top: '250px',
              left: '260px',
              fontSize: '16pt',
            }}>No Data Found!</span>}
        </div>
        <div className={classes.TableBlock}>
        <p className={classes.dataAll}> 
          <div  style={{float:"left",padding:"10px"}}>Data Displayed for All Vehicles </div>
          <div style={{float:"left",padding:"10px 0px 0px 100px",fontSize: '12pt', fontFamily:"Avenir_Medium" }}>
          <div style={{float:"left"}} >
               <div style={{backgroundColor:"#81D3F8", width:"25px", height:"25px",float:"left",marginRight: "7px"}}  ></div> = peak hour
            </div>
            <div  style={{float:"left",padding: "0px 0px 0px 50px"}} >
                <div style={{backgroundColor:"#F59A23", width:"25px", height:"25px",float: "left",marginRight: "7px"}}  ></div> = peak 15-minute
            </div>
          </div>
          </p>
          <div className='mainDivBlock'>

            <TableContainer component={Paper}>
              <Table className={classes.tableMidBlock} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <TableCell align="right" style={{ border: "none", backgroundColor: "transparent" }} className={classes.category, classes.tableHead}>
                    </TableCell>                    
                    <TableCell colSpan={4} align="right" className={classes.tableHead}>
                      {getResponseApproches.length != 0 ? (getResponseApproches.find((ele) => ele.name === "Northbound") ? getResponseApproches.find((ele) => ele.name === "Northbound").value : 'N/A') : 'N/A'}
                      <br />
                      {getResponseApproches.length != 0 ? '(' + (getResponseApproches.find((ele) => ele.name === "Northbound") ? getResponseApproches.find((ele) => ele.name === "Northbound").name : 'Northbound') + ')' : '(Northbound)'}
                    </TableCell>
                    <TableCell colSpan={4} align="right" className={classes.tableHead}>
                      {getResponseApproches.length != 0 ? (getResponseApproches.find((ele) => ele.name === "Southbound") ? getResponseApproches.find((ele) => ele.name === "Southbound").value : 'N/A') : 'N/A'}
                      <br />
                      {getResponseApproches.length != 0 ? '(' + (getResponseApproches.find((ele) => ele.name === "Southbound") ? getResponseApproches.find((ele) => ele.name === "Southbound").name : 'Southbound') + ')' : '(Southbound)'}
                      </TableCell>
                    <TableCell colSpan={4} align="right" className={classes.tableHead}>
                      {getResponseApproches.length != 0 ? (getResponseApproches.find((ele) => ele.name === "Eastbound") ? getResponseApproches.find((ele) => ele.name === "Eastbound").value : 'N/A') : 'N/A'}
                      <br />
                      {getResponseApproches.length != 0 ? '(' + (getResponseApproches.find((ele) => ele.name === "Eastbound") ? getResponseApproches.find((ele) => ele.name === "Eastbound").name : 'Eastbound') + ')' : '(Eastbound)'}
                      </TableCell>
                    <TableCell colSpan={4} align="right" className={classes.tableHead}>                      
                      {getResponseApproches.length != 0 ? (getResponseApproches.find((ele) => ele.name === "Westbound") ? getResponseApproches.find((ele) => ele.name === "Westbound").value : 'N/A') : 'N/A'}
                      <br />
                      {getResponseApproches.length != 0 ? '(' + (getResponseApproches.find((ele) => ele.name === "Westbound") ? getResponseApproches.find((ele) => ele.name === "Westbound").name : 'Westbound') + ')' : '(Westbound)'}
                    </TableCell>
                    <TableCell align="right" style={{ border: "none", backgroundColor: "transparent" }} className={classes.category, classes.tableHead}>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Start Time</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Left</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Thru</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Right</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>U-Turn</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Left</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Thru</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Right</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>U-Turn</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Left</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Thru</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Right</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>U-Turn</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Left</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Thru</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Right</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>U-Turn</TableCell>
                    <TableCell align="right" className={classes.tableHead, classes.textHiglight}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(getResponseData) != "{}" ? getResponseData.map((ele, index) => {
                     let peakResult=getPeakColor(ele.starttime, startPeakHour,endPeakHour,startPeakMin,endPeakMin,flagPeakH,flagPeakM)
                     let colorPeak=peakResult[0];
                     flagPeakH=peakResult[1];
                     flagPeakM=peakResult[2];
                    return (
                      <StyledTableRow >
                        

                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD} >{ele.starttime ? ele.starttime : '00'}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={[classes.dataTD, classes.bLeft]}>{ele.north.left !== "" ? ele.north.left : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.north.thru !== "" ? ele.north.thru : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.north.right !== "" ? ele.north.right : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.north.uturn !== "" ? ele.north.uturn : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={[classes.dataTD, classes.bLeft]}>{ele.south.left !== "" ? ele.south.left : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.south.thru !== "" ? ele.south.thru : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.south.right !== "" ? ele.south.right : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.south.uturn !== "" ? ele.south.uturn : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={[classes.dataTD, classes.bLeft]}>{ele.east.left !== "" ? ele.east.left : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.east.thru !== "" ? ele.east.thru : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.east.right !== "" ? ele.east.right : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.east.uturn !== "" ? ele.east.uturn : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={[classes.dataTD, classes.bLeft]}>{ele.west.left !== "" ? ele.west.left : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.west.thru !== "" ? ele.west.thru : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{ele.west.right !== "" ? ele.west.right : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={[classes.dataTD, classes.bRight]}>{ele.west.uturn !== "" ? ele.west.uturn : ''}</TableCell>
                        <TableCell style={{backgroundColor:colorPeak }} align="right" className={classes.dataTD}>{getDashedArray[index] ? '--' : ele.total}</TableCell>
                      </StyledTableRow>
                    )
                  }) : <StyledTableRow>

                      <TableCell align="center" className={classes.dataTD} colSpan={20}>
                        No Data Available
                    </TableCell>
                    </StyledTableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

      </div> :
      <div style={{textAlign:"center",marginTop:"10%"}}>
          <span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span>
        </div>
        }
    </React.Fragment>
  );
}

export default AM;
//End AM component code...